<template>
  <div class="menu-icon-button" @click="handleClick">
    <vx-tooltip
      :text="tooltipSettings.text"
      :position="tooltipSettings.position"
    >
      <div class="menu-icon cursor-pointer"></div>
    </vx-tooltip>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {
  mapMutations: mapMutationsOfRGPlayback
} = createNamespacedHelpers("radarGridPlayback");
export default {
  name: "RgHistorySettingButton",
  props: {
    tooltipSettings: {
      type: Object,
      default() {
        return {
          text: "",
          position: "right",
        };
      },
    },
  },
  methods: {
    ...mapMutationsOfRGPlayback(["SET_IS_ACTIVE_DATE_INPUT_DIALOG"]),
    handleClick() {
      this.SET_IS_ACTIVE_DATE_INPUT_DIALOG(true)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_mixin.scss";
@import "@/assets/scss/aisea/_variables.scss";

.menu-icon-button {
  .menu-icon {
    border-radius: 5px;
    @include image-button("md");
    background: url("~@/assets/images/icons/lolcal/rg_object_history_menu_default.svg")
      no-repeat;
    background-size: contain;

    &:hover {
      background: url("~@/assets/images/icons/lolcal/rg_object_history_menu_hover.svg")
        no-repeat;
      background-size: contain;
    }

    &:active {
      background: url("~@/assets/images/icons/lolcal/rg_object_history_menu_press.svg")
        no-repeat;
      background-size: contain;
    }
  }
}
</style>
